import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 1.6em;\n  margin-bottom: 20px;\n  color: ", ";\n  button {\n    margin: 0 5px;\n    font: outline;\n    color: inherit;\n    line-height: inherit;\n    text-decoration: underline;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 30px;\n  line-height: 1.1em;\n  margin-bottom: 30px;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 40px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 80px;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Section = styled.h3(_templateObject(), media.xxLargeScreen(_templateObject2()));
export var Title = styled.h3(_templateObject3(), function (props) {
  return props.theme.typography.thinFontFamily;
}, media.xxLargeScreen(_templateObject4()));
export var LoginButton = styled.p(_templateObject5(), function (props) {
  return props.theme.typography.extraFontFamily;
}, function (props) {
  return props.theme.colors.graySemi;
});